module.exports = __webpack_public_path__ + "static/media/view.28c45ef2.svg";